import { Base } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';
import CustomEase from 'gsap/CustomEase.js';

/**
 * @typedef {{}} DropdownProps
 */

/**
 * Dropdown Dropdown.
 * @augments {Base<DropdownProps>}
 */
export default class Dropdown extends Base {
  isOpen = false;

  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Dropdown',
    refs: ['btn', 'close[]', 'list', 'items[]', 'counter', 'input', 'checkboxs[]'],
    emits: ['open'],
  };

  /**
   * @returns {string}
   */
  get inputHasValue() {
    return this.$refs.input.value;
  }

  /**
   *
   */
  mounted() {
    this.tl = gsap.timeline();
    this.tl.pause();

    this.tl.fromTo(
      this.$refs.list,
      {
        y: 50,
      },
      {
        y: 0,
        opacity: 1,
        duration: 0.4,
        ease: CustomEase.create('custom', '0.215, 0.61, 0.355, 1'),
      },
    );
    this.tl.fromTo(
      this.$refs.items,
      {
        opacity: 0,
        y: 10,
      },
      {
        opacity: 1,
        y: 0,
        stagger: 0.1,
        ease: CustomEase.create('custom', '0.215, 0.61, 0.355, 1'),
      },
      '-=0.1',
    );
  }

  /**
   *
   */
  resetDropdown() {
    this.$refs.input.value = '';
    this.$refs.counter.classList.add('scale-0');

    this.$refs.checkboxs.forEach((element) => {
      element.removeAttribute('checked');
    });
  }

  /**
   *
   */
  onCloseClick() {
    this.close();
  }

  /**
   * Stop propagation when click in the element
   * @param {object} props Props
   * @param {object} props.event current event
   * @returns {void}
   */
  onClick({ event }) {
    event.stopPropagation();
  }

  /**
   * Close when clicking outside the element
   * @returns {void}
   */
  onDocumentClick() {
    this.close();
  }

  /**
   *
   */
  onBtnClick() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  /**
   *
   */
  open() {
    this.$emit('open', this);
    this.tl.play();
    this.$refs.list.classList.remove('pointer-events-none');
    this.isOpen = true;
  }

  /**
   *
   */
  close() {
    gsap.to(this.$refs.list, {
      y: 100,
      opacity: 0,
      ease: 'back.in',
      duration: 0.6,
      onComplete: () => {
        this.tl.seek(0);
        this.tl.pause();
      },
    });
    this.$refs.list.classList.add('pointer-events-none');
    this.isOpen = false;
  }
}
